<script setup lang="ts">
import { BtnPrimary } from '@shared/ui/buttons'

import { useButtonTaskCreate } from '../../model/creation/button-task-create.hook'

defineOptions({
  name: 'ButtonTaskCreate',
})

const { setSubmitCreate } = useButtonTaskCreate()
</script>

<template>
  <BtnPrimary
    text="Create task"
    color="emerald"
    @click="setSubmitCreate"
  />
</template>
